module.exports = __webpack_public_path__ + "img/hsab-logo.1bad3a69.png";